import { useEffect, useState } from 'react';

export const useCopyToClipboard = (config = {}) => {
  const { delay = 500 } = config;

  const [copiedText, setCopiedText] = useState(null);

  const copy = async (text) => {
    if (!navigator?.clipboard) {
      // eslint-disable-next-line no-console
      console.warn('Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };

  useEffect(() => {
    if (!copiedText) {
      return undefined;
    }

    const id = setTimeout(() => {
      setCopiedText(null);
    }, delay);

    return () => clearTimeout(id);
  }, [copiedText]);

  return [copiedText, copy];
};
